import {
    LEAD_DETAILS_SUCCESS,
    LEAD_DETAILS_FAILURE,
    LEAD_DETAILS_RESET,
    LEAD_SET_LOADING,
    LEAD_SET_ERROR,
    LEAD_CLEAR_ERROR,
    LEAD_ADD_REQUEST,
    LEAD_ADD_SUCCESS,
    LEAD_ADD_FAILURE,
    LEAD_ADD_RESET
} from '../lead/LeadActionType';

interface LeadState {
    leads: any[];
    employeeInfo: any | null;
    employees: any[]; // Add this line
    loading: boolean;
    error: any | null;
    selectedLead: any | null;
    filters: any;
    message: string;
    manageStatus: {
        loading: boolean;
        success: boolean;
        error: any | null;
        operation: string | null;
        message: string | null;
        response: any | null;
    };
}

const initialState: LeadState = {
    leads: [],
    employeeInfo: null,
    employees: [], // Add this line
    loading: false,
    error: null,
    selectedLead: null,
    filters: {},
    message: '',
    manageStatus: {
        loading: false,
        success: false,
        error: null,
        operation: null,
        message: null,
        response: null
    }
};

const LeadReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case LEAD_SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case LEAD_DETAILS_SUCCESS:
            return {
                ...state,
                leads: action.payload.records || [],
                employeeInfo: action.payload.employeeInfo,
                employees: action.payload.employees || [], // Add this line
                message: action.payload.message,
                error: null,
                loading: false
            };

        case LEAD_DETAILS_FAILURE:
            return {
                ...state,
                error: action.payload,
                message: typeof action.payload === 'string' ? action.payload : '',
                loading: false,
                leads: [],
                employees: [] // Add this line - clear employees on failure
            };

        case LEAD_SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false,
                message: typeof action.payload === 'string' ? action.payload : action.payload?.message || 'An error occurred'
            };

        case LEAD_CLEAR_ERROR:
            return {
                ...state,
                error: null,
                message: ''
            };

        case LEAD_DETAILS_RESET:
            return {
                ...initialState
            };

        case "LEAD_SET_SELECTED":
            return {
                ...state,
                selectedLead: action.payload
            };

        case "LEAD_SET_FILTERS":
            return {
                ...state,
                filters: { ...state.filters, ...action.payload }
            };

        case "LEAD_CLEAR_FILTERS":
            return {
                ...state,
                filters: {}
            };

        // Add Lead Request
        case LEAD_ADD_REQUEST:
            return {
                ...state,
                manageStatus: {
                    loading: true,
                    success: false,
                    error: null,
                    operation: action.payload?.operation || null,
                    message: null,
                    response: null
                }
            };

        // Add Lead Success
        case LEAD_ADD_SUCCESS:
            console.log("LEAD_ADD_SUCCESS reducer action:", action);
            return {
                ...state,
                manageStatus: {
                    loading: false,
                    success: true,
                    error: null,
                    operation: action.payload?.operation || 'INSERT',
                    message: action.payload?.message || 'Operation completed successfully',
                    response: action.payload?.response || action.payload
                },
                // Optionally add the new lead to the list if it's an insert
                leads: action.payload?.operation === 'INSERT' 
                    ? [...state.leads, action.payload?.response] 
                    : state.leads,
                error: null,
                message: action.payload?.message || 'Operation completed successfully'
            };

        // Add Lead Failure
        case LEAD_ADD_FAILURE:
            console.log("LEAD_ADD_FAILURE reducer action:", action);
            const errorMessage = 
                action.payload?.message || 
                (typeof action.payload === 'string' ? action.payload : 'Operation failed');
            
            return {
                ...state,
                manageStatus: {
                    loading: false,
                    success: false,
                    error: action.payload,
                    operation: action.payload?.operation || null,
                    message: errorMessage,
                    response: null
                },
                error: action.payload,
                message: errorMessage
            };

        // Reset Add Lead State
        case LEAD_ADD_RESET:
            return {
                ...state,
                manageStatus: {
                    loading: false,
                    success: false,
                    error: null,
                    operation: null,
                    message: null,
                    response: null
                }
            };

        default:
            return state;
    }
};

export default LeadReducer;